import { dew as _environmentsDew } from "../../../../environments";
import { dew as _coreDew } from "../../../../core";
import { dew as _Dew } from "../../..";
import { dew as _serializationDew } from "../../../../serialization";
import * as _urlJoin2 from "url-join";
var _urlJoin = "default" in _urlJoin2 ? _urlJoin2.default : _urlJoin2;
import { dew as _errorsDew } from "../../../../errors";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  /**
   * This file was auto-generated by Fern from our API Definition.
   */
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Mapping = void 0;
  const environments = __importStar(_environmentsDew());
  const core = __importStar(_coreDew());
  const Flatfile = __importStar(_Dew());
  const serializers = __importStar(_serializationDew());
  const url_join_1 = __importDefault(_urlJoin);
  const errors = __importStar(_errorsDew());
  class Mapping {
    constructor(_options) {
      this._options = _options;
    }
    /**
     * Creates a mapping rule
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    createMapping(request, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, "/mapping/rules"),
          method: "POST",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          body: yield serializers.MappingRuleConfig.jsonOrThrow(request, {
            unrecognizedObjectKeys: "strip"
          }),
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.MappingRuleResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * List all mapping rules
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    listMappings(requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, "/mapping/rules"),
          method: "GET",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.MappingRulesResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    /**
     * Deletes a mapping rule
     * @throws {@link Flatfile.BadRequestError}
     * @throws {@link Flatfile.NotFoundError}
     */
    deleteMapping(mappingId, requestOptions) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, function* () {
        const _response = yield ((_a = this._options.fetcher) !== null && _a !== void 0 ? _a : core.fetcher)({
          url: (0, url_join_1.default)((_b = yield core.Supplier.get(this._options.environment)) !== null && _b !== void 0 ? _b : environments.FlatfileEnvironment.Production, `/mapping/rules/${yield serializers.MappingId.jsonOrThrow(mappingId)}`),
          method: "DELETE",
          headers: {
            Authorization: yield this._getAuthorizationHeader(),
            "X-Disable-Hooks": "true",
            "X-Fern-Language": "JavaScript",
            "X-Fern-SDK-Name": "@flatfile/api",
            "X-Fern-SDK-Version": "1.5.31"
          },
          contentType: "application/json",
          timeoutMs: (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.timeoutInSeconds) != null ? requestOptions.timeoutInSeconds * 1000 : 60000
        });
        if (_response.ok) {
          return yield serializers.MappingRuleResponse.parseOrThrow(_response.body, {
            unrecognizedObjectKeys: "passthrough",
            allowUnrecognizedUnionMembers: true,
            allowUnrecognizedEnumValues: true,
            skipValidation: true,
            breadcrumbsPrefix: ["response"]
          });
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              throw new Flatfile.BadRequestError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            case 404:
              throw new Flatfile.NotFoundError(yield serializers.Errors.parseOrThrow(_response.error.body, {
                unrecognizedObjectKeys: "passthrough",
                allowUnrecognizedUnionMembers: true,
                allowUnrecognizedEnumValues: true,
                skipValidation: true,
                breadcrumbsPrefix: ["response"]
              }));
            default:
              throw new errors.FlatfileError({
                statusCode: _response.error.statusCode,
                body: _response.error.body
              });
          }
        }
        switch (_response.error.reason) {
          case "non-json":
            throw new errors.FlatfileError({
              statusCode: _response.error.statusCode,
              body: _response.error.rawBody
            });
          case "timeout":
            throw new errors.FlatfileTimeoutError();
          case "unknown":
            throw new errors.FlatfileError({
              message: _response.error.errorMessage
            });
        }
      });
    }
    _getAuthorizationHeader() {
      return __awaiter(this, void 0, void 0, function* () {
        return `Bearer ${yield core.Supplier.get(this._options.token)}`;
      });
    }
  }
  exports.Mapping = Mapping;
  return exports;
}